export default function MobileBurgerMenu() {
    let burger = document.querySelector('.burger');
    let body = document.querySelector('body');
    let menu = document.querySelector('.header__nav-mobile > ul');
    let isMenuOpen = false;

    burger.addEventListener('click', function () {
        burger.classList.toggle('close');
        isMenuOpen = !isMenuOpen;
        if (isMenuOpen) {
            menu.style.display = 'flex';
            body.style.overflow = 'hidden';

        } else {
            menu.style.display = 'none';
            body.style.overflow = 'scroll';
        }
    });
}